import React, { Component } from 'react';
import firebase from '../firebase';

export default (WrappedComponent) => {
  return class extends Component {
    render() {
      let restaurantPath;
      const { params } = this.props;

      if( params && params.restaurantId) {
        restaurantPath = firebase.firestore().collection('restaurant').doc(params.restaurantId);
      }
      return <WrappedComponent {...this.props} restaurantPath={restaurantPath} />
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/withFirestorePath.js